import { hasCapability, type User } from "../base";

export const tag = {
  view: (user: User) => hasCapability(user, "tag.view"),
  create: (user: User) => hasCapability(user, "tag.create"),
  update: (user: User) => hasCapability(user, "tag.update"),
  delete: (user: User) => hasCapability(user, "tag.delete"),
};
